import { CREATE, READ, UPDATE, DELETE, SET_MAIN_PAGINATION_TOTAL, SEARCH } from '../../../../store/type'
import { ENTITY_NAME, COMPANY_CONNETCT_CODE, COMPANY_UNCONNECT_CODE, BUDGET_CODE, SUPPLIER_SERVICE, SUPPLIER_SERVICE_CONNECT } from "./type";
import { api } from "../../../../util/api";
import { API_METHODS } from "../../../../constant";

export const actions = {
    [ENTITY_NAME + READ]: async({ state, rootState, commit }, paramsIn = null) => {
        try {
            if (paramsIn.id) {
                return await api(API_METHODS.GET_COMPANY, paramsIn, rootState)
            } else {
                const res = await api(API_METHODS.GET_ALL_COMPANY, paramsIn, rootState)
                commit(ENTITY_NAME + READ, {
                    data: res.object,
                    fieldInfoList: res.fieldInfoList
                })
                commit(SET_MAIN_PAGINATION_TOTAL, {
                    countPage: res.countPage,
                })
                return res
            }
        } catch (err) {
            return err
        }
    },
    [ENTITY_NAME + UPDATE]: async({ commit }, paramsIn = null) => {
        try {
            return await api(API_METHODS.UPDATE_COMPANY, paramsIn)
        } catch (err) {
            return err
        }
    },

    [ENTITY_NAME + CREATE]: async({ commit }, paramsIn = null) => {
        try {
            return await api(API_METHODS.CREATE_COMPANY, paramsIn)
        } catch (err) {
            return err
        }
    },

    [ENTITY_NAME + DELETE]: async({}, paramsIn = null) => {
        try {
            return await api(API_METHODS.DELETE_COMPANY, paramsIn)
        } catch (err) {
            return err
        }
    },
  
    /**
     * @param paramsIn = {self, companyId, codeId}
     * @returns {Promise.<*>}
     * 
     */
    [COMPANY_CONNETCT_CODE]: async({}, paramsIn) => {
        try {
            return await api(API_METHODS.COMPANY_CONNECT_CODE, paramsIn)
        } catch (err) {
            return err
        }
    },
    /**
     * @param paramsIn = {self, companyId, codeId}
     * @returns {Promise.<*>}
     */
    [COMPANY_UNCONNECT_CODE]: async({}, paramsIn) => {
        try {
            return await api(API_METHODS.COMPANY_UNCONNECT_CODE, paramsIn)
        } catch (err) {
            return err
        }
    },


    [SUPPLIER_SERVICE + READ]: async({ state, rootState, commit }, paramsIn = null) => {
        try {
            const res = await api(API_METHODS.GET_ALL_SUPPLIER_SERVICE, paramsIn, rootState)
            commit(SUPPLIER_SERVICE + READ, {
                data: res.object,
                fieldInfoList: res.fieldInfoList
            })
            commit(SET_MAIN_PAGINATION_TOTAL, {
                countPage: res.countPage,
            })
            return res
        } catch (err) {
            return err
        }
    },
    [SUPPLIER_SERVICE_CONNECT]: async({ commit }, paramsIn = null) => {
        try {
            return await api(API_METHODS.CREATE_SUPPLIER_SERVICE, paramsIn)
        } catch (err) {
            return err
        }
    },
    [SUPPLIER_SERVICE + DELETE]: async({}, paramsIn = null) => {
        try {
            return await api(API_METHODS.DELETE_SUPPLIER_SERVICE, paramsIn)
        } catch (err) {
            return err
        }
    }
};